import React, { useState, memo } from 'react';
import {FsStepper, FsStep, useTheme, FsIkon, Box, FsCard, FsH3, FsAlert, FsToast, FsTypography, FsProgress} from '@aviatrix/flights';
import Alert from '../Alert';

import {useSelector} from 'react-redux';

type stepProps = {
    title:string,
    desc:string
}

type StepperProps = {
    labels: Array<stepProps>,
    component:React.ReactElement,
    completed?:boolean | false,
    onStepClick: (step:number)=> void
}

const MEASURMENT = {
    wizard:{
        width:'720px',
        stepperWidth:'250px',
        contentHeight:'440px'
    }
}

const Stepper = ({labels, component, completed, onStepClick}:StepperProps)=>{
    const theme = useTheme();
    
    const step = useSelector((state:any)=>state.step);
    const step_reached = useSelector((state:any)=>state.step_reached);
    

    const wizardStyle = {
        boxShadow: '0px 4px 12px 0px #201E2829',
    }

    const StepperStyle = {
        '& .MuiStep-vertical':{
            position:'relative',
            padding:'0 0 6px 8px',
            borderRadius:'8px 0 0 8px'
        },
        '& .MuiStep-vertical.active':{ // step active box
            background:'#fff',
        },
        '& .Mui-completed .MuiStepIcon-root circle':{ // completed circle svg
            fill:theme.palette.primary.main,
        },
        '& .icon':{
            position:'absolute',
            top:'11px',
            left:'12px',
            fill:'#fff'
        },
        '& .MuiStepIcon-text':{
            display:'none'
        },
        '& .MuiStepLabel-label': {
          color: `${theme.palette.text.light} !important`,
          fontSize:'12px',
          fontWeight:'400',
          zIndex:'100'
        },
        '& .optional-label': {
          display:'block',
          color: theme.palette.text.dark,
          
        },
        '& .MuiStepIcon-root circle':{
          fill:theme.palette.background.dark
        },
        '& .MuiStepIcon-root.Mui-active circle':{
          fill:theme.palette.primary.main,
        },
        '& .completed circle':{
            fill:`${theme.palette.success.main} !important`,
        },
        '& .Mui-completed .MuiStepConnector-line, \
             .Mui-active .MuiStepConnector-line':{
            borderColor:theme.palette.primary.main,
        },
        '& .MuiStepConnector-line':{
          borderColor:theme.palette.background.dark,
          zIndex:1,
          height:'45px',
          margin:'-36px 0 -8px 0'
        },
        '& .MuiStepLabel-iconContainer':{
          marginTop:'-23px'
        },
        '& .MuiStepConnector-vertical':{
            marginLeft:'17px',
            width:'2px',
            zIndex:10
        }
    }


    return (
        <>
            <Box style={{width:MEASURMENT.wizard.width, ...wizardStyle}}>
                <FsCard
                    sx={{background:theme.palette.background.main, gap:2}}
                    title={
                        <Box sx={{
                            borderBottom:`1px solid ${theme.palette.border.light}`,
                            margin:`-10px -16px 0px -16px`,
                            padding:`0px 16px 9px 16px`
                        }}>
                            <FsH3 >Launch Aviatrix: <span style={{color:theme.palette.text.main}}>{labels[step-1].desc}</span> </FsH3>
                        </Box>
                    }
                >
                    
                    <Box display="flex" flexDirection="row" justifyContent="flex-start" gap={0}>
                        <Box sx={{width:MEASURMENT.wizard.stepperWidth}} >
                            
                            <FsStepper activeStep={(step-1)} orientation="vertical" sx={StepperStyle} >
                                {labels && labels.map((label:stepProps, index:number)=>(
                                <FsStep key={index} 
                                    className={`${((step-1) == index && 'active')} ${completed && labels.length == (index+1) && 'completed'}` }   
                                    
                                    onClick={()=>{
                                        
                                        if ( index+1 <= step_reached){
                                            onStepClick(index+1)    
                                        }
                                    }}
                                    sx={{
                                        '& .MuiStepLabel-label': {
                                            cursor:`${index+1 <= step_reached ? 'pointer' : 'not-allowed'}`
                                        }
                                    }}
                                >
                                    <>
                                    {
                                    (index < (step-1)) ? 
                                        <FsIkon className='icon' name="CheckCircleOutlineOutlined"/>
                                        : (index == (step-1) && !completed ? 
                                            <FsIkon className='icon' name="PendingOutlined"/> 
                                            : (index == (step-1) && completed ? 
                                                <FsIkon className='icon' name="CheckCircleOutlineOutlined"/> 
                                                : '')
                                            )
                                    }
                                    </>
                                    {label.title}
                                    <span className='optional-label'>{label.desc}</span>
                                </FsStep>
                                ))}
                            </FsStepper>

                        </Box>

                        <Box sx={{
                            borderRadius:0,
                            background:theme.palette.background.light,
                            margin:'-16px -16px -16px 0',
                            
                            width:'100%',
                            height:MEASURMENT.wizard.contentHeight,
                            overflow:'auto',
                            position:'relative'
                        }}>
                            <Alert/>
                            {component}
                        </Box>

                    </Box>    


                </FsCard>
            </Box>
        </>
    )
}

export default Stepper;